import React from 'react';
import { useSelector } from 'react-redux';

// Packages
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
	const { isAuthenticated, isAdminUser, isAdminUserLoading } = useSelector(state => state.auth);

	// If not authenticated, redirect to auth
	if (!isAuthenticated) {
		return <Navigate to='/auth' />;
	}

	// If still checking admin status, show loading or wait
	if (isAdminUserLoading) {
		return <div>Loading...</div>;
	}

	// If authenticated but not admin, redirect to wizard
	if (!isAdminUser) {
		return <Navigate to='/wizard/start' />;
	}

	// If authenticated and admin, render child components
	return <Outlet />;
}

export default AdminRoute;